"use client";
import { BMPrimitives, BMText } from "@traveloka/district-bloom";
import { ReactNode } from "react";
import { Image, Pressable, StyleSheet } from "react-native";
import LinearGradient from "react-native-linear-gradient";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { CTV_COMPACT_WHITE_LOGO } from "../../../../assets/traveloka-for-corporates-compact-white";
import BMView from "../../../../components/View/BMView";

const MIN_BACKGROUND_HEIGHT = 196; // Default height for the background image

type Props = {
  handleRedirectLogo?(): void;
  ActionComponents: ReactNode[];
  backgroundBorderRadius?: number;
  backgroundHeight?: number;
  title?: string;
  withBackground?: boolean;
};

export default function MobileGenericHeader(props: Props) {
  const {
    handleRedirectLogo,
    ActionComponents,
    backgroundBorderRadius,
    title,
    backgroundHeight = MIN_BACKGROUND_HEIGHT,
    withBackground = true,
  } = props;

  const insets = useSafeAreaInsets();

  return (
    <BMView style={[styles.container, { paddingTop: insets.top }]}>
      <BMView
        align="center"
        justify="between"
        row
        style={[
          styles.header,
          {
            paddingTop: title ? BMPrimitives.BMSize.md : BMPrimitives.BMSize.xl,
          },
        ]}
      >
        {title ? (
          <BMText variant="titleNormal">{title}</BMText>
        ) : (
          <Pressable onPress={handleRedirectLogo} testID="header-logo_button">
            <Image
              source={{ uri: CTV_COMPACT_WHITE_LOGO }}
              style={styles.ctvLogo}
            />
          </Pressable>
        )}
        <BMView spacing="md" row>
          {ActionComponents}
        </BMView>
      </BMView>
      {withBackground && (
        <LinearGradient
          style={[
            styles.image,
            {
              borderBottomRightRadius: backgroundBorderRadius,
              borderBottomLeftRadius: backgroundBorderRadius,
              height: backgroundHeight,
            },
          ]}
          colors={["#0A9AF2", "#06598C"]}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 1 }}
        />
      )}
    </BMView>
  );
}

const styles = StyleSheet.create({
  container: {
    position: "relative",
  },
  header: {
    paddingHorizontal: BMPrimitives.BMSize.md,
    paddingTop: BMPrimitives.BMSize.xl,
    paddingBottom: BMPrimitives.BMSize.md,
    zIndex: 2,
  },
  ctvLogo: {
    width: 133,
    height: 20,
  },
  image: {
    position: "absolute",
    zIndex: -1,
    width: "100%",
  },
});
